export const TeamValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.TeamName.trim()) {
      errors.TeamName = 'Team Name is required';
    } 
  
    return errors;
  };
  
 